import React from 'react';
import { Typography, Toggle } from '@one-thd/sui-atomic-components';
export const InstantCheckoutToggle = ({ isEnrolled, onChangeToggle, }) => {
    const handleChange = () => {
        const upcomingAction = isEnrolled ? 'unenroll' : 're-enroll';
        onChangeToggle(upcomingAction);
    };
    return (React.createElement("div", { className: "sui-col-span-full lg:sui-col-span-5 xl:sui-col-span-5 sui-flex sui-gap-8 sui-items-center", "data-testid": "ic-toggle" },
        React.createElement(Typography, null, "Shop with Instant Checkout"),
        React.createElement(Toggle, { checked: isEnrolled, onChange: handleChange })));
};
